var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"profile-sidebar"},_vm._l((_vm.values),function(val,id){return _c('div',{key:`"sidebar-profile-id-"${id}`,staticClass:"tab",class:{ active: val.value===_vm.active},on:{"click":function($event){return _vm.setValue(val.value)}}},[_vm._v("\n\t\t"+_vm._s(val.name)+"\n\t")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }